const formatObjectAsTable = (obj: Record<string, unknown>): Record<string, unknown>[] =>
  Object.entries(obj).map(([key, value]) => ({
    Key: key,
    Value: value,
  }));

export default formatObjectAsTable;
